<template>
  <ion-grid>
    <ion-row>
      <ion-col size="12" class="current">
        <sensor-widget :showLabel="true" :type="type" :value="value" />
      </ion-col>
    </ion-row>
    <ion-row v-if="alwaysShowMinMax" class="min-max">
      <ion-col>
        {{ minMaxPrefix }}
        {{ $t('sensor.min') }}:
        <sensor-value :type="type"
                      :value="min"
                      class="min-max" />
        <span> &ndash; </span>
        {{ $t('sensor.max') }}:
        <sensor-value :type="type"
                      :value="max" />
      </ion-col>
    </ion-row>
    <ion-row v-else-if="min !== null || max !== null" class="min-max">
      <ion-col>
        {{ minMaxPrefix }}
        {{ $t('sensor.min') }}:
        <sensor-value v-if="min !== null"
                      noLabel
                      :type="type"
                      :value="min" />
        <span v-if="min !== null && max !== null"> &ndash; </span>
        {{ $t('sensor.max') }}:
        <sensor-value v-if="max !== null"
                      noLabel
                      :type="type"
                      :value="max"
        />
      </ion-col>
    </ion-row>
  </ion-grid>
</template>

<script>
import SensorValue from './SensorValue'
import SensorWidget from './SensorWidget'
import { SensorTypeHelper } from '~gro-modules/Sensor'

export default {
  components: {
    SensorValue,
    SensorWidget,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    datetime: {
      required: false,
      default: null,
    },
    min: {
      required: false,
      default: null,
    },
    max: {
      required: false,
      default: null,
    },
    minMaxPrefix: {
      required: false,
      default: 'Last 24h:',
    },
    alwaysShowMinMax: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    typeClass () {
      return SensorTypeHelper.getClassname(this.type)
    },
    typeLabel () {
      return SensorTypeHelper.$t(this.type, 'label')
    },
  },
}
</script>

<style lang="scss" scoped>
.sensor-tile {
  border-left: 3px solid #ccc;
}

.sensor-tile .no-value {
  font-style: italic;
}

.sensor-tile .current .no-value,
.sensor-tile .current .sensor-value {
  font-weight: bold;
  font-size: 225%;
}

.sensor-tile .sensor-value sup {
  font-size: 50%;
}

.min-max {
  font-size: 10px;

  .sensor-value {
    font-size: 90% !important;
  }
}
</style>
